import React from 'react';
import { Table, Empty, Button, Input, Form, Select } from 'antd';
const { Option } = Select;

export default function DetalleReferenciaModal(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-referencia'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el bot+on "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(value)}
                                    />
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Tipo Comprobante',
                        dataIndex: 'idTipoComprobante',
                        key: 'idTipoComprobante',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrIdTipoComprobante[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onChange'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Comprobante"}
                                            optionFilterProp="children"
                                        >
                                            {props.tiposComprobante.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Serie',
                        dataIndex: 'serie',
                        key: 'serie',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrSeries[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Serie"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Documento',
                        dataIndex: 'documento',
                        key: 'documento',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrDocumentos[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Documento"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: '',
                        dataIndex: 'idReferenciaOrigen',
                        className:'hide',
                        key: 'idReferenciaOrigen',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrIdReferenciaOrigen[${row.identifier}]`, { initialValue: value })(
                                        <Input/>
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: '',
                        dataIndex: 'idReferencia',
                        className:'hide',
                        key: 'idReferencia',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrIdReferencia[${row.identifier}]`, { initialValue: value })(
                                        <Input/>
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: '',
                        dataIndex: 'flagInterno',
                        className:'hide',
                        key: 'flagInterno',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagInterno[${row.identifier}]`, { initialValue: value })(
                                        <Input/>
                                    )}
                                </div>
                            );
                        }
                    }
                ]}
            />
        </div>
    );
}